import React from 'react';
import { BrowserRouter as Router, Switch, Route, } from "react-router-dom";

import DownloadPage from './DownloadPage.js';
import Support from './Support.js';

export default () => {
	// homepage "ac" is defined in package.json and it is create-react-app property
	return <Router>
		<Switch>
			<Route path="/ac/support"><Support /></Route>
			<Route path="/ac"><DownloadPage /></Route>
		</Switch>
	</Router>;
}